import * as Yup from 'yup'
const positiveVal = 'Value must be greater than 0'
const basicValidations = {
  productName: Yup.string().required('Product Name is required'),
  customerType: Yup.string().required('Customer Type is required'),
}
const electricValidations = {
  utility: Yup.string().required('Utility is required'),
  unit: Yup.string().required('Unit is Required'),
  rate: Yup.number()
    .required('Rate is required')
    .min(0, 'E_Rate must be greater than or equal to zero'),
  secondRate: Yup.number().positive(positiveVal),
  earlyTerminationFee: Yup.number().positive(positiveVal),
  serviceFee: Yup.number().positive(positiveVal),
  deposit: Yup.number().positive(positiveVal),
  contractType: Yup.string().required('E_contract Type is required'),
  ecode: Yup.string().required('E_Product Code is required').nullable(),
  ebillingMethod: Yup.string().required('E_Billing Method is required'),
}
const gasValidations = {
  grate: Yup.number()
    .required('Rate is required')
    .min(0, 'G_Rate must be greater than or equal to zero'),
  gsecondRate: Yup.number().positive(positiveVal),
  gearlyTerminationFee: Yup.number().positive(positiveVal),
  gserviceFee: Yup.number().positive(positiveVal),
  gdeposit: Yup.number().positive(positiveVal),
  gutility: Yup.string().required('Utility is required'),
  gunit: Yup.string().required('Unit is Required'),
  gcontractType: Yup.string().required('G_contract Type is required'),
  gcode: Yup.string().required('G_Product Code is required').nullable(),
  gbillingMethod: Yup.string().required('G_Billing Method is required'),
}
const billingMethodOptions = [
  {
    id: 'MarketerBillReady',
    value: 'MarketerBillReady',
    type: 'billingMethod',
  },
  {
    id: 'UtilityBillReady',
    value: 'UtilityBillReady',
    type: 'billingMethod',
  },
  {
    id: 'UtilityRateReady',
    value: 'UtilityRateReady',
    type: 'billingMethod',
  },
  {
    id: 'Dual',
    value: 'Dual',
    type: 'billingMethod',
  },
]
export {basicValidations, electricValidations, gasValidations, billingMethodOptions}
